import React from 'react';

const SkeletonBlock = ({ className = '', ...props }) => (
  <div className={`skeleton ${className}`.trim()} aria-hidden="true" {...props} />
);

export const PageSkeleton = () => (
  <div className="skeleton-page" role="status" aria-label="Loading page">
    <div className="skeleton-page-header">
      <SkeletonBlock className="skeleton-title" />
      <SkeletonBlock className="skeleton-subtitle" />
    </div>
    <div className="skeleton-grid skeleton-grid--3">
      {[0, 1, 2].map((item) => (
        <div key={item} className="skeleton-card">
          <SkeletonBlock className="skeleton-media" />
          <SkeletonBlock className="skeleton-line skeleton-line--medium" />
          <SkeletonBlock className="skeleton-line skeleton-line--short" />
        </div>
      ))}
    </div>
  </div>
);

export const NewsSkeleton = () => (
  <div className="news-skeleton" role="status" aria-label="Loading news">
    <SkeletonBlock className="skeleton-title" style={{ marginBottom: '1.5rem', maxWidth: '180px' }} />
    <div className="skeleton-grid skeleton-grid--news">
      {[0, 1, 2, 3, 4, 5].map((item) => (
        <div key={item} className="skeleton-card">
          <SkeletonBlock className="skeleton-media" />
          <SkeletonBlock className="skeleton-line skeleton-line--medium" />
          <SkeletonBlock className="skeleton-line" />
          <SkeletonBlock className="skeleton-line skeleton-line--short" />
        </div>
      ))}
    </div>
  </div>
);

export const GitHubSkeleton = () => (
  <div className="github-projects-container" role="status" aria-label="Loading GitHub projects">
    <SkeletonBlock className="skeleton-github-header" />
    <div className="skeleton-tabs">
      {[0, 1, 2].map((item) => (
        <SkeletonBlock key={item} className="skeleton-tab" />
      ))}
    </div>
    <div className="skeleton-grid skeleton-grid--3">
      {[0, 1, 2, 3, 4, 5].map((item) => (
        <div key={item} className="skeleton-card">
          <SkeletonBlock className="skeleton-line skeleton-line--medium" />
          <SkeletonBlock className="skeleton-line" />
          <SkeletonBlock className="skeleton-line" />
          <SkeletonBlock className="skeleton-line skeleton-line--short" />
        </div>
      ))}
    </div>
  </div>
);

export const ReviewsSkeleton = () => (
  <div className="reviews-page" role="status" aria-label="Loading reviews">
    <div className="container1">
      <section className="reviews-hero">
        <div className="skeleton-page-header" style={{ textAlign: 'center', margin: '0 auto' }}>
          <SkeletonBlock className="skeleton-title" style={{ margin: '0 auto 0.75rem' }} />
          <SkeletonBlock className="skeleton-subtitle" style={{ margin: '0 auto' }} />
        </div>
      </section>
      <section className="reviews-grid" style={{ padding: '30px 0' }}>
        <div className="skeleton-grid skeleton-grid--reviews">
          {[0, 1, 2, 3, 4, 5].map((item) => (
            <div key={item} className="skeleton-card">
              <div className="skeleton-row">
                <SkeletonBlock className="skeleton-avatar" />
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <SkeletonBlock className="skeleton-line skeleton-line--medium" />
                  <SkeletonBlock className="skeleton-line skeleton-line--short" />
                </div>
              </div>
              <SkeletonBlock className="skeleton-line" />
              <SkeletonBlock className="skeleton-line" />
              <SkeletonBlock className="skeleton-line skeleton-line--short" />
            </div>
          ))}
        </div>
      </section>
    </div>
  </div>
);

export const WeatherBodySkeleton = () => (
  <div role="status" aria-label="Loading weather">
    <div className="skeleton-weather-hero">
      <SkeletonBlock className="skeleton-weather-icon" />
      <div>
        <SkeletonBlock className="skeleton-weather-temp" />
        <SkeletonBlock className="skeleton-line skeleton-line--short" style={{ marginTop: '0.75rem' }} />
      </div>
    </div>
    <div className="skeleton-weather-stats">
      <SkeletonBlock className="skeleton-stat" />
      <SkeletonBlock className="skeleton-stat" />
    </div>
    <SkeletonBlock className="skeleton-stat" style={{ height: '120px', width: '100%' }} />
  </div>
);

export const WeatherSkeleton = () => (
  <div className="weather-page" role="status" aria-label="Loading weather">
    <div className="weather-app">
      <header className="weather-header">
        <div className="weather-location">
          <SkeletonBlock className="skeleton-line skeleton-line--medium" style={{ height: '1.75rem', marginBottom: '0.5rem' }} />
          <SkeletonBlock className="skeleton-line skeleton-line--short" />
        </div>
      </header>
      <main className="weather-body">
        <WeatherBodySkeleton />
      </main>
    </div>
  </div>
);

export const AssistantSkeleton = () => (
  <SkeletonBlock className="skeleton-assistant-fab" aria-hidden="true" />
);

export default PageSkeleton;
